import { type SvgProps, SvgWrapper } from '../utils';

export function DoubleChevronRightIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M5.46973 6.46967C5.76262 6.17678 6.23738 6.17678 6.53027 6.46967L11.5303 11.4697C11.8232 11.7626 11.8232 12.2373 11.5303 12.5302L6.53027 17.5302C6.23738 17.8231 5.76262 17.8231 5.46973 17.5302C5.17683 17.2373 5.17683 16.7626 5.46973 16.4697L9.93945 11.9999L5.46973 7.53022C5.17683 7.23732 5.17683 6.76256 5.46973 6.46967Z" />
      <path d="M12.4697 6.46967C12.7626 6.17678 13.2374 6.17678 13.5303 6.46967L18.5303 11.4697C18.8232 11.7626 18.8232 12.2373 18.5303 12.5302L13.5303 17.5302C13.2374 17.8231 12.7626 17.8231 12.4697 17.5302C12.1768 17.2373 12.1768 16.7626 12.4697 16.4697L16.9395 11.9999L12.4697 7.53022C12.1768 7.23732 12.1768 6.76256 12.4697 6.46967Z" />
    </SvgWrapper>
  );
}
